import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import GoogleIcon from "@mui/icons-material/Google";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../firebase";
import { theme } from "./theme";

const LoginContainer = styled(Box)(() => ({
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  background: theme.colors.background,
  padding: theme.spacing.lg,
}));

const LoginButton = styled(Button)(() => ({
  backgroundColor: theme.colors.white,
  color: theme.colors.text,
  padding: "12px 24px",
  borderRadius: theme.borderRadius.md,
  boxShadow: theme.shadows.medium,
  textTransform: "none",
  fontSize: "1rem",
  fontWeight: 500,
  display: "flex",
  gap: "12px",
  "&:hover": {
    backgroundColor: theme.colors.white,
    transform: "translateY(-2px)",
    boxShadow: theme.shadows.large,
  },
}));

const Title = styled(Typography)(() => ({
  color: theme.colors.text,
  fontSize: "2rem",
  fontWeight: 700,
  marginBottom: theme.spacing.xl,
  textAlign: "center",
  background: `linear-gradient(45deg, ${theme.colors.primary}, ${theme.colors.primaryDark})`,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
}));

const Login: React.FC = () => {
  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (error) {
      console.error("Error signing in with Google:", error);
    }
  };

  return (
    <LoginContainer>
      <Title variant="h1">Voice Assistant</Title>
      <LoginButton
        onClick={handleGoogleLogin}
        variant="contained"
        startIcon={<GoogleIcon />}
      >
        Sign in with Google
      </LoginButton>
    </LoginContainer>
  );
};

export default Login;
